import { Action, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { TypedUseSelectorHook, useDispatch as reactReduxUseDispatch, useSelector as reactReduxUseSelector } from 'react-redux';
import { ThunkAction } from 'redux-thunk';

import { apiSlice } from './features/api/apiSlice';
import rootReducer, { RootState } from './rootReducer';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: ({
        ignoredActions: [
          'viewer1dOption/getImage1dSuccess',
          'viewer2dOption/getImage2dSuccess',
        ],
        // ignoredActionPaths: [
        //   'meta.arg', // Default value
        //   'meta.baseQueryMeta', // Default value
        //   'payload.image',
        // ],
        ignoredPaths: [
          'viewer1dOption.image',
          'viewer2dOption.image',
        ],
      }),
    }).concat(apiSlice.middleware),
});

setupListeners(store.dispatch);

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./rootReducer', () => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const newRootReducer = require('./rootReducer').default;
    store.replaceReducer(newRootReducer);
  });
}

export type AppDispatch = typeof store.dispatch;

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export const useAppDispatch = () => reactReduxUseDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = reactReduxUseSelector;

export default store;
